const INSTALLATION = {
  PAGE_TITLE: 'Installation | Raychat',

  HEADING_TITLE: 'Widget Installation',
  HEADING_SUBTITLE:
    'Install Raychat on your website using one of the following methods.',

  INSTALLATION_HELP: 'Installation Guide',

  INSTALLATION_METHOD_1: 'First Method: Manual Installaiton',
  INSTALLATION_METHOD_1_SUBTITLE:
    'To activate Raychat (manually), copy the following code before ending the head tag.',

  SELECT_WEBSITE: 'Select Website',
  COPY_SCRIPT: 'Copy the Script',
  COPIED: 'Copied!',

  INSTALLATION_METHOD_2: 'Second Method: Plugin',
  INSTALLATION_METHOD_2_SUBTITLE:
    'If you use content management systems (CMS), you can easily use Raychat with a few clicks.',

  INSTALL_PLUGIN: 'Install Plugin',

  WORDPRESS: 'Wordpress',
  JOOMLA: 'Joomla',
  DROPAL: 'Dropal',
  PRESTASHOP: 'Prestashop',
  WHMCS: 'WHMCS',

  WEBSITE_TOKEN: 'Selected Website Token:',
  WIDGET_LINK: 'Widget Link:',
  CLICK_TO_COPY: 'Click To Copy',
  NEW_VERSION: 'New Version',

  NORMAL_LOAD_TYPE: 'Normal code',
  SEO_FRIENDLY_LOAD_TYPE: 'SEO friendly code',
  SPEEDY_LOAD_TYPE: 'Fast load code',
};

export default INSTALLATION;
